var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductlistCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1 7.29999H16.5V9.69999H18.1C18.8 9.69999 19.3 10.2 19.3 10.9V18.1C19.3 18.8 18.8 19.3 18.1 19.3H10.9C10.2 19.3 9.69999 18.8 9.69999 18.1V16.7H7.29999V18.1C7.29999 20.1 8.89999 21.7 10.9 21.7H18.1C20.1 21.7 21.7 20.1 21.7 18.1V10.9C21.7 8.89999 20.1 7.29999 18.1 7.29999Z",
    fill: "#414B56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.89999 2.69999C3.19999 2.69999 2.69999 3.19999 2.69999 3.89999V11.1C2.69999 11.8 3.19999 12.3 3.89999 12.3H11.1C11.8 12.3 12.3 11.8 12.3 11.1V3.89999C12.3 3.19999 11.8 2.69999 11.1 2.69999H3.89999ZM11.1 14.7H3.89999C1.89999 14.7 0.299988 13.1 0.299988 11.1V3.89999C0.299988 1.89999 1.89999 0.299988 3.89999 0.299988H11.1C13.1 0.299988 14.7 1.89999 14.7 3.89999V11.1C14.7 13.1 13.1 14.7 11.1 14.7Z",
    fill: "#414B56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductlistCopy);
export default __webpack_public_path__ + "static/media/icon_productlist_copy.d01a01224f493b4457a834c6d9581bf7.svg";
export { ForwardRef as ReactComponent };